import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Body, Footer, Page } from '@sigeco/tools';
import { Backdrop, CircularProgress, Button, Icon, Grid, Typography, CardContent, Box, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import StatCard from '../../components/fuerzaventas/repositorio/StatCard';
import DataGrid from '../../components/fuerzaventas/repositorio/DataGrid';

const useStyles = makeStyles((theme) => ({
    gridContainer: {
        marginBottom: theme.spacing(2),
    },
}));

const Repositorio = ({ onClose, setTitle }) => {
    const classes = useStyles();
    const loading = useSelector((state) => state.metas.loading);
    //const dispatch = useDispatch();

    useEffect(() => {
        setTitle('Repositorio');
        // eslint-disable-next-line
    }, []);
    function onBtnClose() {
        onClose();
    }
    const data = [
        {
            title: 'Users',
            value: '14k',
            interval: 'Last 30 days',
            trend: 'up',
            data: [200, 24, 220, 260, 240, 380, 100, 240, 280, 240, 300, 340, 320, 360, 340, 380, 360, 400, 380, 420, 400, 640, 340, 460, 440, 480, 460, 600, 880, 920],
        },
        {
            title: 'Conversions',
            value: '325',
            interval: 'Last 30 days',
            trend: 'down',
            data: [1640, 1250, 970, 1130, 1050, 900, 720, 1080, 900, 450, 920, 820, 840, 600, 820, 780, 800, 760, 380, 740, 660, 620, 840, 500, 520, 480, 400, 360, 300, 220],
        },
        {
            title: 'Event count',
            value: '200k',
            interval: 'Last 30 days',
            trend: 'neutral',
            data: [500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620, 510, 530, 520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430, 520, 510],
        },
    ];
    return (
        <Page>
            <Backdrop style={{ position: 'absolute', zIndex: 1200 }} open={loading} transitionDuration={0}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Body>
                <Typography component="h2" variant="h6" mb={2}>
                    Resumen
                </Typography>
                <Grid container spacing={2} className={classes.gridContainer}>
                    {data.map((card, index) => (
                        <Grid item key={index} xs={12} sm={6} lg={3}>
                            <StatCard card={card} />
                        </Grid>
                    ))}
                </Grid>
                <Typography component="h2" variant="h6" mb={2}>
                    Detalles
                </Typography>
                <Grid container spacing={2} columns={12}>
                    <Grid xs={12} lg={3}>
                        {/* <CustomizedDataGrid / */}
                        <DataGrid />
                    </Grid>
                    <Grid xs={12} lg={3}>
                        <div>CustomizedTreeView</div>
                        {/* <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
                            <CustomizedTreeView />
                            <ChartUserByCountry />
                        </Stack> */}
                    </Grid>
                </Grid>
            </Body>
            <Footer>
                <Button color="primary" size="small" variant="outlined" onClick={() => onBtnClose()} startIcon={<Icon className="fas fa-door-open" />}>
                    Salir
                </Button>
            </Footer>
        </Page>
    );
};

export default Repositorio;
